import { AnimatePresence, motion } from 'framer-motion'
import { X, Cpu, MemoryStick, HardDrive } from 'lucide-react'
import { useServerHealth } from '../context/ServerHealthContext'
import './AlertBanner.css'

const ALERT_ICONS = {
  cpu: Cpu,
  ram: MemoryStick,
  disk_root: HardDrive,
  disk_data: HardDrive
}

const ALERT_LABELS = {
  cpu: 'CPU',
  ram: 'RAM',
  disk_root: 'Disk /',
  disk_data: 'Disk /mnt/data'
}

function AlertBanner() {
  const { visibleAlerts, dismissAlert } = useServerHealth()

  return (
    <AnimatePresence>
      {visibleAlerts.map(alert => {
        const Icon = ALERT_ICONS[alert.type] || HardDrive
        const label = ALERT_LABELS[alert.type] || alert.type
        const isCritical = alert.level === 'critical'

        return (
          <motion.div
            key={alert.type}
            className={`alert-banner ${isCritical ? 'alert-critical' : 'alert-warning'}`}
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
          >
            <div className="alert-banner-inner">
              <Icon size={16} className="alert-banner-icon" />
              <span className="alert-banner-label">{label}</span>
              <span className="alert-banner-message">{alert.message}</span>
              <button
                className="alert-banner-dismiss"
                onClick={() => dismissAlert(alert.type)}
                title="Dismiss"
              >
                <X size={14} />
              </button>
            </div>
          </motion.div>
        )
      })}
    </AnimatePresence>
  )
}

export default AlertBanner
